import React, { useState, useEffect, useRef } from 'react';
import {
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaClock,
  FaPaperPlane,
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
  FaCheckCircle,
  FaExclamationCircle,
  FaHandsHelping,
  FaFileAlt,
  FaUserFriends,
  FaShieldAlt,
  FaArrowRight
} from 'react-icons/fa';
import './Contactos.css';
import API_BASE_URL from '../config/api';

const Contactos = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: '', text: '' }); // 'success' | 'error' | ''
  const formRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleApoioSocialClick = () => {
    setFormData(prev => ({
      ...prev,
      subject: 'apoio_social',
      message: prev.message || 'Olá, gostaria de obter informações sobre o processo de candidatura à Bolsa de Apoio Social.'
    }));
    if (formRef.current) {
      formRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // highlight effect or focus
      const textarea = formRef.current.querySelector('textarea');
      if (textarea) setTimeout(() => textarea.focus(), 500);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', text: '' });

    try {
      const response = await fetch(`${API_BASE_URL}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        setStatus({ type: 'success', text: 'Mensagem enviada com sucesso! Entraremos em contacto em breve.' });
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
      } else {
        let errorMsg = 'Erro ao enviar mensagem. Tente novamente.';
        if (data.errors) {
          const errorList = Object.values(data.errors).flat();
          errorMsg = errorList.join(' ');
        } else if (data.message) {
          errorMsg = data.message;
        }
        setStatus({ type: 'error', text: errorMsg });
      }
    } catch (error) {
      console.error('Error:', error);
      setStatus({ type: 'error', text: 'Erro ao enviar mensagem. Verifique a sua ligação.' });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="contact-page">
      <section className="page-header">
        <div className="container">
          <h1>Contactos</h1>
          <p>Estamos aqui para responder às suas questões e ajudá-lo a fazer parte da nossa família desportiva.</p>
        </div>
      </section>

      {/* Secção de Destaque: Bolsa de Apoio Social */}
      <section className="apoio-social-banner-section">
        <div className="container">
          <div className="apoio-social-banner">
            <div className="apoio-social-banner-content">
              <div className="apoio-social-badge">
                <FaHandsHelping /> Apoio Social
              </div>
              <h2>Bolsa de Apoio Social</h2>
              <p className="apoio-social-lead">
                O Clube Desportivo da Póvoa apoia todos os jovens e famílias no acesso ao desporto.
                <strong> Mesmo sem ser sócio</strong>, qualquer atleta ou encarregado de educação pode solicitar a Bolsa de Apoio Social para redução de mensalidades.
              </p>

              <div className="apoio-social-highlights">
                <div className="apoio-highlight-item">
                  <FaUserFriends className="highlight-icon" />
                  <div>
                    <strong>Aberto a Todos</strong>
                    <span>Não é necessário ser sócio prévio para requerer o apoio.</span>
                  </div>
                </div>

                <div className="apoio-highlight-item">
                  <FaFileAlt className="highlight-icon" />
                  <div>
                    <strong>Enquadramento Justo</strong>
                    <span>Apoio atribuído com base nos escalões e rendimento do agregado.</span>
                  </div>
                </div>

                <div className="apoio-highlight-item">
                  <FaShieldAlt className="highlight-icon" />
                  <div>
                    <strong>Confidencialidade Total</strong>
                    <span>Análise sigilosa e rigorosa de toda a documentação.</span>
                  </div>
                </div>
              </div>

              <div className="apoio-social-actions">
                <button
                  type="button"
                  className="apoio-social-cta-btn"
                  onClick={handleApoioSocialClick}
                >
                  Solicitar Informações sobre a Bolsa <FaArrowRight />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-section">
        <div className="container">
          <div className="contact-content">
            <div className="contact-info-side">
              <h2>Entre em Contacto</h2>

              <div className="contact-detail">
                <div className="contact-icon-box">
                  <FaMapMarkerAlt />
                </div>
                <div className="contact-detail-text">
                  <h4>Sede</h4>
                  <p>Largo Dr. José Pontes<br />4490-556 Póvoa de Varzim</p>
                </div>
              </div>

              <div className="contact-detail">
                <div className="contact-icon-box">
                  <FaPhone />
                </div>
                <div className="contact-detail-text">
                  <h4>Geral</h4>
                  <p>+351 252 682 109</p>
                </div>
              </div>

              <div className="contact-detail">
                <div className="contact-icon-box">
                  <FaEnvelope />
                </div>
                <div className="contact-detail-text">
                  <h4>Email</h4>
                  <p>geral@cdpovoa.pt</p>
                </div>
              </div>

              <div className="horario-box">
                <h4>Horário da Secretaria</h4>
                <div className="horario-row">
                  <span>Segunda a Sexta</span>
                  <span>14h30 - 19h00</span>
                </div>
                <div className="horario-row">
                  <span>Sábados</span>
                  <span>09h30 - 12h00</span>
                </div>
              </div>
            </div>

            <div className="contact-form-side" ref={formRef}>
              <h3>Envie-nos uma Mensagem</h3>

              {status.text && (
                <div className={`alert-toast ${status.type}`} style={{
                  padding: '16px',
                  borderRadius: '12px',
                  marginBottom: '24px',
                  background: status.type === 'success' ? '#f0fdf4' : '#fff1f2',
                  border: `1px solid ${status.type === 'success' ? '#dcfce7' : '#fee2e2'}`,
                  color: status.type === 'success' ? '#10b981' : '#ef4444',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  fontWeight: 600
                }}>
                  {status.type === 'success' ? <FaCheckCircle /> : <FaExclamationCircle />}
                  <span>{status.text}</span>
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Nome Completo</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="O seu nome"
                    required
                    disabled={loading}
                  />
                </div>

                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="seu.email@exemplo.com"
                    required
                    disabled={loading}
                  />
                </div>

                <div className="form-group">
                  <label>Assunto</label>
                  <select
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    disabled={loading}
                  >
                    <option value="">Selecione um assunto</option>
                    <option value="apoio_social">Bolsa de Apoio Social</option>
                    <option value="inscricoes">Inscrições</option>
                    <option value="informacoes">Informações Gerais</option>
                    <option value="socio">Quotas / Sócio</option>
                    <option value="instalacoes">Pavilhões / Instalações</option>
                    <option value="outros">Outros</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Mensagem</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Escreva aqui a sua mensagem..."
                    required
                    minLength={10}
                    disabled={loading}
                  ></textarea>
                </div>

                <button type="submit" className="contacts-btn-submit-home" disabled={loading}>
                  {loading ? 'A enviar...' : 'Enviar Mensagem'} <FaPaperPlane />
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <section className="map-section">
        <div className="container">
          <h2>Como Chegar</h2>
          <div className="map-container">
            <iframe
              src="https://maps.google.com/maps?q=Clube%20Desportivo%20da%20P%C3%B3voa,%20Largo%20Dr.%20Jos%C3%A9%20Pontes,%204490-556%20P%C3%B3voa%20de%20Varzim&t=&z=15&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="500"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização do CDP"
            ></iframe>
          </div>
        </div>
      </section>

      <section className="departments-section">
        <div className="container">
          <h2>Departamentos</h2>
          <div className="departments-grid">
            <div className="department-card">
              <h3>Secretaria Geral</h3>
              <div className="department-item">
                <FaPhone />
                <span>+351 252 682 109</span>
              </div>
              <div className="department-item">
                <FaEnvelope />
                <span>geral@cdpovoa.pt</span>
              </div>
            </div>

            <div className="department-card">
              <h3>Inscrições & Atendimento</h3>
              <div className="department-item">
                <FaPhone />
                <span>+351 252 684 400</span>
              </div>
              <div className="department-item">
                <FaEnvelope />
                <span>atendimento@cdpovoa.pt</span>
              </div>
            </div>

            <div className="department-card">
              <h3>Direção Técnica</h3>
              <div className="department-item">
                <FaPhone />
                <span>+351 252 682 109</span>
              </div>
              <div className="department-item">
                <FaEnvelope />
                <span>desporto@cdpovoa.pt</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="social-cta-section">
        <div className="container">
          <h2>Siga-nos nas Redes Sociais</h2>
          <p>Fique por dentro de todas as novidades, jogos e eventos do CDP.</p>
          <div className="social-icons-large">
            <a href="https://facebook.com/cdpovoa" target="_blank" rel="noopener noreferrer" className="social-icon-large">
              <FaFacebookF />
            </a>
            <a href="https://instagram.com/cdpovoa" target="_blank" rel="noopener noreferrer" className="social-icon-large">
              <FaInstagram />
            </a>
            <a href="https://twitter.com/cdpovoa" target="_blank" rel="noopener noreferrer" className="social-icon-large">
              <FaTwitter />
            </a>
            <a href="https://linkedin.com/company/cdpovoa" target="_blank" rel="noopener noreferrer" className="social-icon-large">
              <FaLinkedinIn />
            </a>
          </div>
        </div>
      </section>

      <section className="faq-section">
        <div className="container">
          <h2>Perguntas Frequentes</h2>
          <div className="faq-list">
            <div className="faq-item">
              <h3>Como posso inscrever o meu filho numa modalidade?</h3>
              <p>As inscrições podem ser feitas presencialmente na secretaria do clube ou através do nosso portal de atendimento. Necessitará do CC do atleta e do encarregado de educação.</p>
            </div>

            <div className="faq-item">
              <h3>Quais são os horários das aulas?</h3>
              <p>Os horários variam por modalidade e escalão. Pode consultar os horários atualizados na secção de cada modalidade ou contactar a secretaria.</p>
            </div>

            <div className="faq-item">
              <h3>Têm treinos de captação?</h3>
              <p>Sim! Realizamos treinos de captação regularmente. Siga as nossas redes sociais ou contacte o departamento desportivo para saber as datas das próximas sessões.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contactos;